module.exports = __webpack_public_path__ + "static/media/hospital.e074f816.webp";